<template>
  <article class="iv2-article">
    <transition mode="out-in" :name="animation" appear>
      <div v-if="pageActive">
        <Error404 v-if="openType === 0" />

        <div v-else-if="openType === 1">
          <BaseTitle :items="items" />
          <BaseBreadcrumb :items="items.breadcrumb" />
          <LayoutPattern :items="items" />
        </div>
      </div>
    </transition>

    <div v-if="loading">
      <BaseLoading />
    </div>
  </article>
</template>

<script>
import BaseTitle from "@/components/items/BaseTitle.vue";
import BaseBreadcrumb from "@/components/items/BaseBreadcrumb.vue";
import LayoutPattern from "./components/LayoutPattern.vue";
import BaseLoading from "@/components/items/BaseLoading.vue";
import Error404 from "@/components/systems/Page404.vue";
import Meta from "@/mixins/MetaSettable";
import Hash from "@/mixins/AnchorLink";
import Preview from "@/mixins/Preview";

export default {
  components: {
    BaseTitle,
    BaseBreadcrumb,
    LayoutPattern,
    BaseLoading,
    Error404,
  },

  mixins: [Meta, Hash, Preview],

  props: {
    animation: String,
  },

  data() {
    return {
      items: {},
      openType: "",
      loading: true,
      pageActive: false,
    };
  },

  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        this.loading = true;
        this.pageActive = false;
        this.getFreePages();
      }
    },
  },

  mounted() {
    this.getFreePages();
  },

  methods: {
    getFreePages() {
      const segment = this.$route.params.segment_name;
      const freepagesRepository = this.$repository.get("freepages");
      const freepages = freepagesRepository.show(
        segment,
        this.$route.query.mode,
        this.$route.query.api_token
      );
      const self = this;
      freepages
        .then((result) => {
          self.items = result.data.response;
          if (self.$route.query.mode == "preview") {
            self.openType = 1;
          } else {
            self.openType = self.items.open_type;
          }
        })
        .catch((error) => {
          console.error(error);
          self.openType = 0;
        })
        .finally(() => {
          self.loading = false;
          self.pageActive = true;
        });
    },
  },
};
</script>

<style lang="scss"></style>
